/**
 * @see https://stackoverflow.com/a/15724300/7453363
 */
export function getTempAuthCookie(cookieName: string): string | undefined {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${cookieName}=`);

	if (parts.length === 2) return parts.pop()?.split(';').shift();
}

/**
 * @see https://stackoverflow.com/a/23995984/7453363
 */
export function invalidateTempAuthCookie(cookieName: string, domain: string) {
	document.cookie = `${cookieName}=;domain=${domain};path=/;max-age=0;`;
}

export function setTempAuthCookie(cookieName: string, domain: string, storageAuthKey: string) {
	document.cookie = `${cookieName}=${sessionStorage.getItem(storageAuthKey) as string};domain=${domain};path=/;`;
}
